(function ($) {

  var $window = $(window),
          partnersslider;

    var wow = new WOW(
      {
        boxClass:     'wow', 
        animateClass: 'animated', 
        offset:       0,  
        mobile:       true, 
        live:         true,       
        callback:     function(box) {

        },
        scrollContainer: null 
      }
    );
    wow.init();

    $('li.current-menu-item, li.current-category-ancestor').addClass('load');

    if ( $('#homeSlider').length) { 
      $window.load(function() {
        $('#homeSlider').flexslider({
          animation: "fade",
          slideshowSpeed: 7000,   
          animationSpeed: 1000, 
          smoothHeight: true,
          prevText: "",
          nextText: "", 
        });
      });
    }

    if ( $('#partners-slider').length) {   
         
        $window.load(function() {
          $('#partners-slider').flexslider({
            controlNav: false,
            prevText: "",
            nextText: "",
            animation: "slide",
            animationLoop: false,
            itemWidth: 230,
            itemMargin: 0,
            minItems: getGridSize(),
            maxItems: getGridSize(),
            start: function(slider){
                      partnersslider = slider;
            }
          });
        });
       
        $window.resize(function() {
          var gridSize = getGridSize();
       
          partnersslider.vars.minItems = gridSize;
          partnersslider.vars.maxItems = gridSize;
        });
  
    } 

    function getGridSize() {
      return (window.innerWidth < 600) ? 1 :
             (window.innerWidth < 800) ? 2 : 
             (window.innerWidth < 1000) ? 3 : 
             (window.innerWidth < 1200) ? 4 : 5;
    } 

    $('.toggle-menu').on('click', function(event) {

      event.preventDefault();
      $(this).toggleClass('active');
      $('#mainNav').slideToggle();

    });

    $(".scrollTop").click(function() {
        $("html, body").animate({scrollTop: 0}, "slow");
        return false;
    });

    $('#contactForm .control').on('focus', function(){
        $(this).closest('.form-group').addClass('focused');
    });

    $('#contactForm .control').on('blur', function(){
        $(this).closest('.form-group').removeClass('focused');
    });

    $('#contactForm .control').on('change', function(){
        var value = $(this).val();
        if(value) {
          $(this).closest('.form-group').removeClass('empty');
        }
        else {
          $(this).closest('.form-group').addClass('empty');
        }
    });

    $('.equal').matchHeight();
 
    $('.gmap').each(function(){
      
      render_map( $(this) );

    }); 

    (function(proxied) {
      window.alert = function() {
        swal({
          title: arguments[0],
          type: "error"
        });
        //return proxied.apply(this, arguments);
      };
    })(window.alert); 

var map, marker;

/*
*  render_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $el (jQuery element)
*  @return  n/a
*/

function render_map( $el ) {

  // var
  var $markers = $el.find('.marker');
        $el.addClass('activated');

  // vars
  
  var map_settings_gray = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
  var args = {
    zoom    : 14,
    center    : new google.maps.LatLng(0, 0),
    scrollwheel: false,
    styles: map_settings_gray,
    mapTypeId : google.maps.MapTypeId.ROADMAP
  };

  // create map           
  map = new google.maps.Map( $el[0], args);

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function(){

      add_marker( $(this), map );

  });

  // center map
  center_map( map );

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $marker (jQuery element)
*  @param map (Google Map object)
*  @return  n/a
*/

function add_marker( $marker, map ) {

  // var
  var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

  // create marker
  
  var image = vars.templateurl + '/img/marker.png';
  marker = new google.maps.Marker({
    position  : latlng,
    map : map,
                icon: image
  });

  // add to array
  map.markers.push( marker );

  // if marker contains HTML, add it to an infoWindow
  if( $marker.html() )
  {
    // create info window
    var infowindow = new google.maps.InfoWindow({
      content   : $marker.html()
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {

      infowindow.open( map, marker );

    });
  }

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param map (Google Map object)
*  @return  n/a
*/

function center_map( map ) {

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each( map.markers, function( i, marker ){

    var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

    bounds.extend( latlng );

  });

  // only 1 marker?
  if( map.markers.length == 1 )
  {
    // set center of map
      map.setCenter( bounds.getCenter() );
      map.setZoom( 13 );
  }
  else
  {
    // fit to bounds
    map.fitBounds( bounds );
  }

}

}(jQuery));
